import {
  ChangeDetectorRef,
  Component,
  Inject,
  OnInit,
  ViewChild,
} from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { TypeCesEnum } from 'src/app/domain/registration/enums/type-ces.enum';
import { ISystemAction } from 'src/app/domain/registration/models/ISystemAction';
import { DynamicFormComponent } from 'src/app/shared/components/dynamic-form/containers/dynamic-form/dynamic-form.component';
import { CES_CONFIG_FIELDS } from '../crud-config';
import { IFieldConfig } from 'src/app/domain/IFieldConfig';

@Component({
  selector: 'app-system-action-ces',
  templateUrl: './crud-ces.component.html',
  styleUrls: ['./crud-ces.component.sass'],
})
export class SystemActionCESComponent implements OnInit {
  @ViewChild(DynamicFormComponent) form: DynamicFormComponent;
  config: IFieldConfig[] = CES_CONFIG_FIELDS;
  data: ISystemAction;
  type: TypeCesEnum;
  title = '--';

  get typeCesEnum() {
    return TypeCesEnum;
  }

  setFields() {
    // PADRÃO
    this.form.setDisabled('submit', true);
    this.form.setValue('id', this.data?.id);
    // NA CÓPIA ALTERA APENAS ESSES
    this.form.setValue('name', this.data?.name);
  }

  constructor(
    public dialogRef: MatDialogRef<SystemActionCESComponent>,
    @Inject(MAT_DIALOG_DATA)
    data: { type: TypeCesEnum; element: ISystemAction },
    private cdr: ChangeDetectorRef
  ) {
    this.type = data.type;
    this.data = data.element;
    this.title = this.type;
  }

  ngOnInit(): void {}

  ngAfterViewInit() {
    let previousValid = this.form.valid;

    this.form.changes.subscribe(() => {
      if (this.form.valid !== previousValid) {
        previousValid = this.form.valid;
        this.form.setDisabled('submit', !previousValid);
      }
    });

    this.setFields();
    this.cdr.detectChanges();
  }

  onSubmit(value: { [name: string]: any }) {
    this.dialogRef.close({ element: value });
  }

  onCancel() {
    this.dialogRef.close();
  }

  changeType(type: TypeCesEnum) {
    this.type = type;
    this.dialogRef.close({ changeType: type });
  }

  delete() {
    this.dialogRef.close({ delete: true });
  }
}
